import React, { useState, useEffect } from "react";
import "../Styles/ServiceP.css";
import approachData from "../Data/ApproachData";
import Hero from "../Components/Hero";
import { Link } from "react-router-dom";
import Process from "../Components/Process";
import { useLocation } from 'react-router-dom';
function Service() {

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const [data, setData] = useState(approachData);
  const [showMore, setShowMore] = useState(false);
  return (
    <>
      <div className="contact_container">
        <Hero link="Home" pageName="Loan Guides" />
      </div>
      <div   data-aos="fade-down"
                  // data-aos-duration="1500"
                  data-aos-mirror="true"
                  data-aos-once="false"
                  data-aos-easing="ease-in-out" className="servicep_container">
        <div className="scontainer">
          <div className="service_guides_intro">
            <p className="service_sub_title">Educational resources</p>
            <h1 className="service_title">Explore Loan Guides</h1>
            <p>
              These guides explain common terms, documents and scheme
              information. PyLoan does not accept or process loan applications.
            </p>
          </div>
          <div className="row">
            {data.map((detail) => {
              const { id, img, title, desc, slug } = detail;
              return (
                <div className="col-lg-4 col-md-6 col-xs-12" key={id}>
                  <div className="servicep_card">
                    <img src={img} alt={title} />
                    <div className="servicep_text">
                      <h4>{title}</h4>
                      <p>
                        {desc}
                      </p>
                      <Link to={`/service/${slug}`} className="service_readmore">
                        Learn More <i class="fa-solid fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <Process />
        </div>
      </div>
    </>
  );
}

export default Service;
